import React from "react"
import airInsightLogo from "../../images/air-insight-logo.png"

const TRACK = "#3B5CC4"
const FILL = "#ABE8E8"
const RADIUS = 42
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

const STATS = [
  { figure: "−94%", label: "cost-per-click", percent: 94 },
  { figure: "−51%", label: "cost-per-lead", percent: 51 },
  { figure: "+27%", label: "hot leads", percent: 27 },
]

const Ring = ({ percent }) => {
  const dash = (Math.min(Math.max(percent, 0), 100) / 100) * CIRCUMFERENCE

  return (
    <svg viewBox="0 0 100 100" className="block w-full h-auto" aria-hidden="true">
      <circle
        cx="50"
        cy="50"
        r={RADIUS}
        fill="none"
        stroke={TRACK}
        strokeWidth="10"
      />
      <circle
        cx="50"
        cy="50"
        r={RADIUS}
        fill="none"
        stroke={FILL}
        strokeWidth="10"
        strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
        strokeLinecap="butt"
        transform="rotate(-90 50 50)"
      />
    </svg>
  )
}

const AirResultsPanel = () => (
  <div className="bg-secondary-dark">
    <div className="flex flex-col px-8 py-16 md:flex-row md:flex-wrap md:items-center md:py-20 lg:flex-nowrap xl:py-24">
      <div className="w-full mb-6 md:mb-5 lg:w-1/4 lg:mb-0 lg:pr-4">
        <img src={airInsightLogo} alt="Air Insight" width="114" height="29" className="block mb-3" />
        <p className="mb-1 text-sm text-white">[Air used alongside PPC]</p>
        <p className="mb-0 text-2xl leading-tight text-white font-display lg:text-3xl">Mobile Veterinary Practice</p>
      </div>
      {STATS.map(({ figure, label, percent }) => (
        <div className="flex items-center w-full mb-5 md:w-1/3 md:mb-0 md:pr-4 lg:w-1/4 lg:mb-0" key={label}>
          <div className="flex-none w-32 lg:w-24 xl:w-32">
            <Ring percent={percent} />
          </div>
          <div className="pl-4">
            <p className="mb-0 text-3xl leading-none font-display text-secondary-light xl:text-4xl">{figure}</p>
            <p className="mb-0 text-sm text-white">{label}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default AirResultsPanel
